import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaTimes } from "react-icons/fa";

const ScrollDepthCTA = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(
    () => !!sessionStorage.getItem("ctaDismissed")
  );

  useEffect(() => {
    if (dismissed) return;
    const handleScroll = () => {
      const docH = document.documentElement.scrollHeight - window.innerHeight;
      if (docH > 0 && (window.scrollY / docH) * 100 > 65) {
        setVisible(true);
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [dismissed]);

  const dismiss = () => {
    setVisible(false);
    setDismissed(true);
    sessionStorage.setItem("ctaDismissed", "1");
  };

  if (dismissed) return null;

  return (
    <div
      className={`scroll-depth-cta${visible ? " scroll-depth-cta--visible" : ""}`}
      role="complementary"
      aria-label="Project inquiry prompt"
    >
      <button
        className="scroll-cta-close"
        onClick={dismiss}
        aria-label="Dismiss"
      >
        <FaTimes />
      </button>
      <p className="scroll-cta-eyebrow">Ready to start?</p>
      <h4 className="scroll-cta-heading">
        Let's build something uncopyable.
      </h4>
      <Link to="/contact" className="scroll-cta-btn" onClick={dismiss}>
        Start a Project <FaArrowRight />
      </Link>
    </div>
  );
};

export default ScrollDepthCTA;
